import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import BoxButton from "../../Layout/components/BoxButton";
import BoxSection from "../../Layout/components/BoxSection";
import ButtonStrip from "../../Layout/components/ButtonStrip";

import {
  displayModalCreate,
  adicionarConfiguracion,
  eliminarConfiguracion,
  almacenarParametro,
  resetAfterTipoCampo
} from "../actions";

import { showModalConfirmAction } from "../../Layout/actions";

class ModalCreate extends Component {
  modalContent = () => {
    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.almacenarParametro();
        }}
        noValidate
      >
        <ButtonStrip
          actions={[
            <BoxButton
              key="ba[-1][0]"
              name="floppy-o"
              title="Guardar"
              disabled={this.props.saving}
            />
          ]}
        />
        <div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="control-label">Nombre</label>
                <Input
                  type="text"
                  reducer="parameters"
                  path="modalCreate.data.nombre"
                  disabled={this.props.modalCreate.get("mode") === "edit"}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="control-label">Categoría</label>
                <Input
                  type="text"
                  reducer="parameters"
                  path="modalCreate.data.categoria"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label">Descripción</label>
                <Input
                  type="textarea"
                  reducer="parameters"
                  path="modalCreate.data.descripcion"
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12">
              <BoxSection
                title="Configuración"
                actions={[
                  <BoxButton
                    key="ba[0][0]"
                    size={14}
                    contrast
                    name="plus-circle"
                    onClick={e => {
                      e.preventDefault();
                      this.props.adicionarConfiguracion();
                    }}
                    title="Nueva"
                  />,
                  <BoxButton
                    key="ba[0][1]"
                    size={14}
                    contrast
                    name="trash"
                    onClick={e => {
                      e.preventDefault();
                      this.props.showModalConfirmAction(
                        true,
                        "Está seguro que desea eliminar los registros seleccionados?",
                        () => this.props.eliminarConfiguracion()
                      );
                    }}
                    title="Eliminar"
                    disabled={
                      this.props.modalCreate.get("data") &&
                      this.props.modalCreate
                        .getIn(["data", "configuraciones"])
                        .filter(x => x.get("selected"))
                        .count() === 0
                    }
                    danger
                  />
                ]}
              >
                <div
                  className="box-content"
                  style={{
                    height: "188px",
                    overflowX: "hidden",
                    background: "#f5f5f5"
                  }}
                >
                  <table className="table table-condensed table-bordered">
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "25px"
                          }}
                        ></th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.modalCreate.get("data") &&
                        this.props.modalCreate
                          .getIn(["data", "configuraciones"])
                          .map((x, n) => {
                            const path = `modalCreate.data.configuraciones.${n}`;
                            return (
                              <tr
                                key={`tr6[${x.get("id") || x.get("guid")}]`}
                                className={x.get("selected") ? "info" : ""}
                              >
                                <td
                                  style={{
                                    lineHeight: "23px"
                                  }}
                                >
                                  <Input
                                    type="checkbox"
                                    reducer="parameters"
                                    path={`${path}.selected`}
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="text"
                                    reducer="parameters"
                                    path={`${path}.nombre`}
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="text"
                                    reducer="parameters"
                                    path={`${path}.descripcion`}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </BoxSection>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    return (
      <Modal
        ancho="40vw"
        mostrar={this.props.modalCreate.get("show")}
        contenido={this.modalContent()}
        titulo={this.props.modalCreate.get("title")}
        nombre="modal_create_parametros"
        maximizable={true}
        onCerrarModal={() => this.props.displayModalCreate(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreate: state.parameters.get("modalCreate"),
    parametros: state.parameters.get("parametros"),
    saving: state.parameters.get("saving")
  };
};

const mapDispatchToProps = dispatch => {
  return {
    displayModalCreate: show => dispatch(displayModalCreate(show)),
    adicionarConfiguracion: () => dispatch(adicionarConfiguracion()),
    eliminarConfiguracion: () => dispatch(eliminarConfiguracion()),
    almacenarParametro: () => dispatch(almacenarParametro()),
    resetAfterTipoCampo: path => dispatch(resetAfterTipoCampo(path)),
    showModalConfirmAction: (show, message, action) =>
      dispatch(showModalConfirmAction(show, message, action))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
